import React, { useEffect, useState } from 'react';

import { arrowRightIcon } from '../img/icons';

/**
 * BlockInfo
 *
 * A DWT reusable component
 *
 * @param {Object} props
 * @param {string} props.featureBy
 */
const Dropdown = ({ options, placeholder, handleDropdown }) => {
  const [ isOpen, setIsOpen ] = useState( false );
  const [ selected, setSelected ] = useState( null );

  const getSelected = () => selected ? selected.label : placeholder;

  const onItemClick = ( e, option ) => {
    setSelected( option );
    handleDropdown( e );
  };

  useEffect( () => {
    const handler = () => setIsOpen( false );
    window.addEventListener( 'click', handler );
    // return () => window.removeListener( 'click', handler );
  }, [] );

  const handleInputClick = ( e ) => {
    e.stopPropagation();
    setIsOpen( !isOpen );
  };

  return (
    <div className='dropdown-wrapper cursor-pointer' onClick={ handleInputClick }>

      <div className={ `dropdown__selected-item flex items-center gap-10 border ${!isOpen ? 'border-b' : 'border-b-transparent'} border-solid border-gray py-10 px-20` }>
        <span>{ getSelected() }</span>
        <span className={` ${!isOpen ? 'rotate-90' : '-rotate-90'}` }>{ arrowRightIcon }</span>
      </div>

      { isOpen && (
        <ul className='dropdown__list flex flex-col bg-white w-[12rem] absolute right-0 list-none p-0 border border-solid border-gray z-10'>

          { options.map( ( option ) => (
            <li
              className="dropdown__list-item mb-0 py-10 px-20 hover:bg-light-gray"
              data-value={ option.value }
              data-direction={ option.direction ?? null }
              key={ self.crypto.randomUUID() }
              onClick={ ( e ) => onItemClick( e, option ) }
            >
              { option.label }
            </li>
          ) ) }

        </ul>

      ) }

    </div>
  );
};

export default Dropdown;
